import { element } from './dom.js';

const VALID_TYPES = new Set(['success', 'error', 'warning', 'info']);

export function createToastManager(host = document.body) {
  const region = element('section', {
    className: 'toast-region',
    'aria-label': 'Notifiche',
    'aria-live': 'polite',
    'aria-relevant': 'additions text',
  });
  host.appendChild(region);
  const timers = new Set();

  function notify({ type = 'info', text = '' } = {}) {
    const tone = VALID_TYPES.has(type) ? type : 'info';
    const message = String(text || '').trim();
    if (!message) return;

    const toast = element('div', {
      className: `app-toast app-toast--${tone}`,
      role: tone === 'error' ? 'alert' : 'status',
    }, [
      element('span', { className: 'material-icons', 'aria-hidden': 'true' },
        tone === 'success' ? 'check_circle' : tone === 'error' ? 'error' : tone === 'warning' ? 'warning' : 'info'),
      element('span', { className: 'app-toast__text' }, message),
      element('button', {
        className: 'app-toast__close',
        type: 'button',
        'aria-label': 'Chiudi notifica',
        onClick: () => remove(),
      }, element('span', { className: 'material-icons', 'aria-hidden': 'true' }, 'close')),
    ]);

    let timer = null;
    const remove = () => {
      if (timer) {
        clearTimeout(timer);
        timers.delete(timer);
        timer = null;
      }
      toast.remove();
    };
    region.appendChild(toast);
    timer = setTimeout(remove, tone === 'error' ? 8000 : 5000);
    timers.add(timer);
  }

  function destroy() {
    timers.forEach(clearTimeout);
    timers.clear();
    region.remove();
  }

  return Object.freeze({ notify, destroy });
}
